export default "__VITE_ASSET__47fdffe7__"